import Fragment from "./fragment";
import FragmentDataType from "../enums/fragment-data-type";
import FragmentSummary from "./fragment-summary";
import { playerReducer } from "../../../storage/reducers";
import PatType from "../enums/pat-type";
import RushedByPositionPref from "./position-pref/rushed-by-position-pref";
import { FragmentMessages } from "../../common/fragment-messages";
import FootballState from "../state/football-state";
import RushType from "../enums/rush-type";

export default class Run extends Fragment {
    constructor(runBy, fieldPosition, rushType) {
        super();

        this.patType = PatType.RUSH.code;
        this.runBy = runBy;
        this.fieldPosition = fieldPosition;
        this.rushType = rushType;

        this.requiredData = [
            {
                name: "runBy",
                type: FragmentDataType.Player,
                displayName: "Rushed by",
                title: (team) => `Rushed By: ${team.teamName}`,
                subtitle: (team) =>
                    `Select a player
                     from ${team.teamName} or enter the roster number`,
                isEditable: true,
                positionPref: (play) =>
                    new RushedByPositionPref(play, this).resolve()
            },
            {
                name: "rushType",
                type: FragmentDataType.RushType,
                displayName: "Rushed to",
                title: "Rushed to",
                subtitle: () => "Select direction of rush",
                isEditable: true,
                optional: true
            },
            {
                name: "fieldPosition",
                type: FragmentDataType.FieldPosition,
                displayName: "At",
                title: "At",
                subtitle: FragmentMessages.FB_TEAM_FIELD_POSITION,
                requiredAfterNextState: [
                    FootballState.Tackle,
                    FootballState.OutOfBounds
                ]
            }
        ];
    }

    getFragmentTeamId() {
        return this.runBy?.teamId;
    }

    getPlayers() {
        return [this.runBy];
    }

    summarize(summaryContext, stringifier) {
        let message = `${stringifier.firstInitial(this.runBy)} ${
            summaryContext?.gameConfig?.scoring?.runPAT
        }-point rush attempt`;

        if (this.rushType && this.rushType.code !== RushType.SKIP.code) {
            message += ` ${this.rushType.name.toLowerCase()}`;
        }

        message += ` for ${stringifier.gain(
            summaryContext,
            summaryContext.fieldPosition,
            this.fieldPosition
        )}`;

        return new FragmentSummary(message);
    }

    updateSummaryContext(summaryContext) {
        if (this.fieldPosition || this.fieldPosition === 0) {
            summaryContext.fieldPosition = this.fieldPosition;
        }

        summaryContext.playerInPossession = this.runBy;
    }

    toJSON() {
        return {
            ...super.toJSON(),
            runBy: playerReducer(this.runBy)
        };
    }

    getScoringPoints(gameConfig) {
        return gameConfig.scoring.runPAT;
    }

    getFieldPosition() {
        return this.fieldPosition;
    }

    excludeRequiredData(rd, gameConfig) {
        if (rd.name === "rushType") {
            return !gameConfig.general.rushType;
        }

        return false;
    }
}
